import { Component } from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles';

export default class SearchResultShowAdvanced extends Component {
  TRANSLATED_SHOW_ADVANCED_SEARCH = I18n.t('js.learner.search.show_advanced_search');

  TRANSLATED_SHOW_MORE_RESULTS = I18n.t('js.learner.search.show_more_results');

  componentDidUpdate() {
    if (this.props.isActive) {
      this.activeItem?.scrollIntoView({
        // scrolls only if element is about to go off viewable list
        block: 'nearest',
      });
    }
  }

  render() {
    const { emptyText, isActive, onSelect } = this.props;
    const activeClass = isActive ? 'default-search-result--active' : '';
    const innerText = emptyText
      ? `${emptyText} - ${this.TRANSLATED_SHOW_ADVANCED_SEARCH}`
      : this.TRANSLATED_SHOW_MORE_RESULTS;

    return (
      <div
        ref={(activeItem) => {
          this.activeItem = activeItem;
        }}
        className={`default-search-result ${activeClass}`}
        onClick={onSelect}
      >
        <TextWrapper className="default-search-result--inner">{innerText}</TextWrapper>
        <div className="default-search-result--mask" />
      </div>
    );
  }
}

const TextWrapper = styled.div`
  justify-content: center;
  color: #3b3b3b;
  font-size: 0.85rem;
  ${theme.font.semibold}
`;
